/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';

/**
 * Internal dependencies
 */
import './style.scss';

export const Original = (): JSX.Element => (
	<p className="nab-php-original-version">
		{ _x(
			'Current appearance with no extra changes',
			'text',
			'nelio-ab-testing'
		) }
	</p>
);
